import React from 'react';
import CommonBanner from "../component/Common/CommonBanner";
import { ImageConstants } from "../assets/img/ImageConstants";
import BookYourTravel from '../component/BookYourTravel';
import StaticSEOTags from '../component/DynamicSEO/StaticSEOTags';
import Img from "../assets/img/common/big_banner.png";
const VisaDocumentationGuide = () => {
  return (
    <>
      <StaticSEOTags
          fallbackTitle="Visa Documentation Guide - Polifly Travels"
          fallbackDescription="Get expert guidance on visa documentation from Polifly Travels. Complete document preparation support for tourist, business, student, and family visit visas."
          fallbackKeywords="visa documentation, visa application, document preparation, Polifly Travels"
          fallbackOgTitle="Visa Documentation Guide - Polifly Travels"
          fallbackOgDescription="Get expert guidance on visa documentation from Polifly Travels. Complete document preparation support for tourist, business, student, and family visit visas."
          fallbackCanonicalUrl="https://poliflytravels.com/visa-documentation-guide/"
        />
      <CommonBanner
        heading="Visa Documentation Guide"
        img={ImageConstants.visabanner}
        pagination="Visa Documentation Guide"
      />
      
      {/* Main Content Section */}
      <section className="visa-documentation-area pt-20 pb-120 mt-20 mt-5">
        <div className="container mt-5">
        <div className='row'>
  <div className='col-lg-6 visa-content'>  
  <h2 className="mb-4 visa-content">Polifly Travels – Making Visa Applications Easier for You</h2>
                <p className=" mb-5">
                  At Polifly Travels, we understand how crucial it is to submit accurate and complete documents when applying for a visa. That's why we offer a reliable and easy-to-follow visa documentation guide to make the process smoother for you.
                </p>
  </div>
  <div className='col-lg-6'>
  <img src={Img} alt="img" />
  </div></div>
          <div className="row">
            <div className="col-lg-12">
              <div className="content-wrapper visa-content">
             

                <div className="what-we-offer mb-5">
                  <h3 className="mb-4">What We Offer</h3>
                  <p>
                    We provide end-to-end guidance for preparing documents for tourist, business, student, and family visit visas. Our experienced team ensures your paperwork is complete and complies with the latest embassy requirements.
                  </p>
                </div>

           



                <div className="row pt-5">
            <div className="col-md-6">
              <div className="destinations-section mb-5">
              <h3 className="mb-4">Our Services Include</h3>
                  <ul className="benefits-list">
                    <li>Country-specific document checklists</li>
                    <li>Assistance with visa application form filling</li>
                    <li>Professional review of documents before submission</li>
                    <li>Appointment booking support</li>
                    <li>Help with writing cover letters and sponsorship letters</li>
                    <li>Travel insurance and dummy flight bookings (if needed)</li>
                  </ul>
                  <h3 className="mb-4 mt-5">Visa Documentation Support for Multiple Countries</h3>
                  <p >
                    We offer documentation support for a wide range of countries, including but not limited to:
                  </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="why-choose-section mb-5">
              <h3 className="mb-4">Why Choose Polifly Travels?</h3>
                  <ul className="benefits-list">
                    <li>Simple and step-by-step guidance</li>
                    <li>A professional team with years of experience</li>
                    <li>Saves your time and minimizes chances of visa rejection</li>
                    <li>Perfect for both first-time and frequent travelers</li>
                  </ul>
              </div>
            </div> </div>




                <div className="get-in-touch">
                  <h3 className="mb-4">Get in Touch</h3>
                  <p>
                    If you're planning to apply for a visa but are unsure about the documentation process, Polifly Travels is here to help. We'll walk you through each step and ensure your paperwork is prepared perfectly.
                  </p>
                  <div className="contact-info mt-4">
                    <p><strong>Contact us today for expert visa documentation assistance!</strong></p>
                    <div className="contact-buttons">
                      <a href="/contact" className="btn btn-primary me-3">Contact Us</a>
                      <a href="tel:+923001234567" className="btn btn-outline-primary">Call Now</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* <BookYourTravel /> */}
    </>
  );
};

export default VisaDocumentationGuide; 